import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const original = error.config;
    const isAuthCall = original?.url?.startsWith("/auth/");
    if (error.response?.status === 401 && !original?._retry && !isAuthCall) {
      original._retry = true;
      try {
        await api.post("/auth/refresh");
        return api(original);
      } catch {
        if (original?.url?.startsWith("/rc/")) window.dispatchEvent(new Event("sap:signedout"));
        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  }
);

export const PASSWORD_HINT = "At least 12 characters, with upper and lower case letters, a number and a symbol.";

export const trackDownload = (resource) => {
  api.post("/downloads", { resource }).catch(() => {});
};

export const errorText = (e) => {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d?.msg || "").filter(Boolean).join(" ");
  return detail?.msg || String(detail);
};
